import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=a662934a&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"
import style0 from "./DictItemList.vue?vue&type=style&index=0&id=a662934a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a662934a",
  null
  
)

export default component.exports